
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';

export function SubscriptionsFooter() {
  return (
    <Card>
      <CardContent className="pt-6">
        <div className="text-sm text-gray-500">
          <p>Need help with your subscriptions? <a href="/contact" className="text-blue-600 hover:underline">Contact us</a></p>
          <p className="mt-1">Questions about billing? Check your <a href="/dashboard" className="text-blue-600 hover:underline">account information</a></p>
        </div>
      </CardContent>
    </Card>
  );
}
